module.exports = __webpack_public_path__ + "static/media/Hovata_White_Logo.c2f2da02.svg";